import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row, Nav, Container, Tab, Accordion, Modal, Table, Form, InputGroup } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import './PriceList.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Search } from 'react-bootstrap-icons';

function PriceList() {
    const [searchTerm, setSearchTerm] = useState('');
    const customBsPrefix = 'custom-accordion';

    const { kitchenThingsData } = useSelector(
        (state) => state.kitchenThings
    );
    console.log(kitchenThingsData);


    const { bedroomThingsData } = useSelector(
        (state) => state.bedroomThings
    );

    const { foyerThingsData } = useSelector(
        (state) => state.foyerThings
    );

    const { livingThingsData } = useSelector(
        (state) => state.livingThings
    );

    const { otherWorkThingsData } = useSelector(
        (state) => state.OtherWorkThings
    );

    const { looseThingsData } = useSelector(
        (state) => state.looseThings
    );

    const { accessoriesThingsData } = useSelector(
        (state) => state.accessories
    );

    // Function to filter items based on search term
    const filterItemsBySearch = (items) => {
    if (!searchTerm) return items;

    return items.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||

        item.material.some(mat =>
            mat.label.toLowerCase().includes(searchTerm.toLowerCase()) ||

            mat.subMaterials?.some(sub =>
                sub.subLabel.toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
    );
};
    

    // Get all categories data for global search
    const allCategories = [
        { name: 'Kitchen', data: kitchenThingsData },
        { name: 'Bedroom', data: bedroomThingsData },
        { name: 'Foyer', data: foyerThingsData },
        { name: 'Living Room', data: livingThingsData },
        { name: 'Other Works', data: otherWorkThingsData },
        { name: 'Loose Furniture', data: looseThingsData },
        { name: 'Accessories', data: accessoriesThingsData },
    ];

    // Filter categories with matching items
    const matchedCategories = searchTerm ?
        allCategories.filter(category =>
            filterItemsBySearch(category.data).length > 0
        ) :
        [];

    // Function to render an item row
    // const renderItemRow = (item) => (
    //     <Row key={item.name} style={{display:'flex', flexDirection:'row'}}>
    //         <Col sm={2} style={{backgroundColor:'whitesmoke',display:'flex', flexDirection:'column', justifyContent:'center', padding:'10px', borderBottomColor:'whitesmoke', border:'solid' }}>
    //             <p style={{fontWeight:'bold'}}>{item.name} <br/> 
    //                 <span style={{fontWeight:'normal'}}>
    //                     ({item.measurement === "area" ? "Area" : 
    //                       item.measurement === "width" ? "Width & Height" : 
    //                       item.measurement === "rft" ? "RFT" :  
    //                       item.measurement === "qty" ? "Quantity" : 
    //                       item.measurement === "length" ? "Length & Width" : 
    //                       item.measurement === "selection" ? "Type" : null})
    //                 </span>
    //             </p>
    //         </Col>

    //         {item.material.map((item2, index2) => (
    //             <Col sm={1} key={index2} style={{borderRadius:5, backgroundColor:'whitesmoke', padding:'10px', marginRight:'10px' ,marginBottom:'10px'}}>
    //                 <p className='w-100'>{item2.label}</p>
    //                 <input type='number' value={item2.value} placeholder='price' className='w-100' disabled/>
    //                 <input type='number' value={item2.oldvalue} placeholder='price' className='w-100' disabled/>
    //                  {item2.subMaterials && (
    //                 <div sm={1} key={index2} style={{borderRadius:5, backgroundColor:'whitesmoke', padding:'10px', marginRight:'10px' ,marginBottom:'10px'}}>
    //                     <p className='w-100'>sathish</p>
    //                     {/* <input type='number' value={item2.subMaterial.value} placeholder='price' className='w-100' disabled/> */}
    //                 </div>
    //             )}
    //             </Col>
    //         ))}
    //     </Row>
    // );


    const renderItemRow = (item) => (
        <div style={{
            display: 'flex',
            height: 'auto',
            border: '1px solid whitesmoke',
            borderBottom: '1px solid black',
            justifyContent: 'start',
            alignItems: 'stretch',  // changed from 'center' so both columns match height
        }}>
            <div style={{
                width: '250px',
                minWidth: '250px',  // prevent shrinking
                display: 'flex',
                justifyContent: 'start',
                padding: '50px 10px 10px 30px',
                borderRight: '1px solid whitesmoke',
                fontWeight: 'bold',
            }}>{item.name}</div>

            <div style={{
                fontFamily: "'DM Sans', sans-serif",
                display: "flex",
                justifyContent: "start",
                padding: 10,
                alignItems: "flex-start",  // changed from 'center' so cards align to top
                background: "#f0f3fa",
                flexWrap: 'wrap',
                gap: 10,  // added gap between cards instead of relying on margin
                flex: 1,  // take remaining width
            }}>
                {item.material.map((item2, index2) => (
                    <div key={item.name + '-' + index2} style={{  // added key prop
                        width: 'auto',
                        background: "#fff",
                        border: "1.5px solid #e4e8f0",
                        borderRadius: 10,
                        overflow: "hidden",
                        boxShadow: "0 2px 12px rgba(30,42,74,0.08)",
                    }}>
                        {/* Header */}
                        <div style={{
                            padding: "11px 16px",
                            background: "#f0f4ff",
                            borderBottom: "1px solid #e4e8f0",
                            fontWeight: 700,
                            fontSize: 14,
                            color: "#1e2a4a",
                        }}>
                            {item2.label}
                        </div>

                        {/* Rows */}
                        {/* Rows */}
                          <div style={{ padding: "10px 16px 14px", display: "flex", flexDirection: "column", gap: 10 }}>
                           
                                <div  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontSize: 12.5, color: "#6b7a99", width: 150, whiteSpace: 'normal', wordBreak: 'break-word', padding: 5 }}>
                                      {'standard'}
                                      {/* {item2.subMaterials ? 'standard' : item2.label} */}
                                    </span>

                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>

                                        {/* OLD price */}
                                        <div style={{
                                            display: "flex", alignItems: "center",
                                            background: "#fff7ed", border: "1px solid #fed7aa",
                                            borderRadius: 6, padding: "5px 8px", gap: 3,
                                        }}>
                                            <span style={{ fontSize: 9, color: "#9a3412", fontWeight: 700 }}>OLD</span>
                                            <span style={{ color: "#9a3412", fontSize: 12 }}>₹</span>
                                            <input
                                                type="number"
                                                value={item2.oldValue ?? 0}
                                                placeholder="old rate"
                                                readOnly
                                                style={{
                                                    border: "none", background: "transparent",
                                                    width: 52, fontSize: 13, fontWeight: 600,
                                                    color: "#9a3412", outline: "none",
                                                    fontFamily: "'DM Sans', sans-serif", textAlign: 'right',
                                                }}
                                            />
                                        </div>

                                        <span style={{ fontSize: 10, color: "#94a3b8" }}>→</span>

                                        {/* NEW price */}
                                        <div style={{
                                            display: "flex", alignItems: "center",
                                            background: "#eff6ff", border: "1px solid #bfdbfe",
                                            borderRadius: 6, padding: "5px 8px", gap: 3,
                                        }}>
                                            <span style={{ fontSize: 9, color: "#1d4ed8", fontWeight: 700 }}>NEW</span>
                                            <span style={{ color: "#1d4ed8", fontSize: 12 }}>₹</span>
                                            <input
                                                type="number"
                                                value={item2.value ?? 0}
                                                placeholder="new rate"
                                                readOnly
                                                style={{
                                                    border: "none", background: "transparent",
                                                    width: 52, fontSize: 13, fontWeight: 600,
                                                    color: "#1d4ed8", outline: "none",
                                                    fontFamily: "'DM Sans', sans-serif", textAlign: 'right',
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                
                        </div>
                        <div style={{ padding: "10px 16px 14px", display: "flex", flexDirection: "column", gap: 10 }}>
                            {item2.subMaterials?.map((item3, index3) => (
                                <div key={item.name + '-' + item2.label + '-' + index3} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontSize: 12.5, color: "#6b7a99", width: 150, whiteSpace: 'normal', wordBreak: 'break-word', padding: 5 }}>
                                        {item3.subLabel}
                                    </span>

                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>

                                        {/* OLD price */}
                                        <div style={{
                                            display: "flex", alignItems: "center",
                                            background: "#fff7ed", border: "1px solid #fed7aa",
                                            borderRadius: 6, padding: "5px 8px", gap: 3,
                                        }}>
                                            <span style={{ fontSize: 9, color: "#9a3412", fontWeight: 700 }}>OLD</span>
                                            <span style={{ color: "#9a3412", fontSize: 12 }}>₹</span>
                                            <input
                                                type="number"
                                                value={item3.subOldValue ?? 0}
                                                placeholder="old rate"
                                                readOnly
                                                style={{
                                                    border: "none", background: "transparent",
                                                    width: 52, fontSize: 13, fontWeight: 600,
                                                    color: "#9a3412", outline: "none",
                                                    fontFamily: "'DM Sans', sans-serif", textAlign: 'right',
                                                }}
                                            />
                                        </div>

                                        <span style={{ fontSize: 10, color: "#94a3b8" }}>→</span>

                                        {/* NEW price */}
                                        <div style={{
                                            display: "flex", alignItems: "center",
                                            background: "#eff6ff", border: "1px solid #bfdbfe",
                                            borderRadius: 6, padding: "5px 8px", gap: 3,
                                        }}>
                                            <span style={{ fontSize: 9, color: "#1d4ed8", fontWeight: 700 }}>NEW</span>
                                            <span style={{ color: "#1d4ed8", fontSize: 12 }}>₹</span>
                                            <input
                                                type="number"
                                                value={item3.subValue ?? 0}
                                                placeholder="new rate"
                                                readOnly
                                                style={{
                                                    border: "none", background: "transparent",
                                                    width: 52, fontSize: 13, fontWeight: 600,
                                                    color: "#1d4ed8", outline: "none",
                                                    fontFamily: "'DM Sans', sans-serif", textAlign: 'right',
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )

    return (
        <Container fluid>
            <Row>
                <Col className='px-5 pb-5'>
                    <img src={require('../assests/sitelogo.png')} alt='Dashboard' className='logoImg' />
                </Col>
            </Row>

            {/* Search Bar */}
            <Row className="mb-4 px-3">
                <Col md={6} className="mx-auto">
                    <InputGroup>
                        <InputGroup.Text>
                            <Search />
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            placeholder="Search items by name or material..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                            <InputGroup.Text
                                style={{ cursor: 'pointer' }}
                                onClick={() => setSearchTerm('')}
                            >
                                ✕
                            </InputGroup.Text>
                        )}
                    </InputGroup>
                </Col>
            </Row>

            {/* Search Results Section */}
            {searchTerm && (
                <Row className="mb-4">
                    <Col>
                        <Accordion defaultActiveKey="search-results">
                            <Accordion.Item eventKey="search-results">
                                <Accordion.Header>Search Results</Accordion.Header>
                                <Accordion.Body>
                                    {matchedCategories.length === 0 ? (
                                        <p className="text-center">No items found matching "{searchTerm}"</p>
                                    ) : (
                                        matchedCategories.map(category => (
                                            <div key={category.name}>
                                                <h5 className="mt-3 mb-3">{category.name}</h5>
                                                {filterItemsBySearch(category.data).map(item => renderItemRow(item))}
                                            </div>
                                        ))
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            )}

            {/* Regular Accordion Categories */}
            <Row>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Kitchen</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(kitchenThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Bedroom</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(bedroomThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Foyer</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(foyerThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Living Room</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(livingThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Other Works</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(otherWorkThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Loose Furniture</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(looseThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Accessories</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(accessoriesThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button mt-3"
                    table={'sanjay'}
                    filename="price-list"
                    sheet="price-list"
                    buttonText="Download as Excel"
                    cellStyles={[
                        '.your-class {background-color: #ffffff;}',
                    ]}
                />

                <Table id={'sanjay'} striped bordered hover className="border d-none">
                    <tbody>
                        <tr><th>Kitchen</th></tr>
                        {kitchenThingsData.map((item, index) => (
                            <tr key={`kitchen-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`kitchen-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}

                        <tr><th>Bedroom</th></tr>
                        {bedroomThingsData.map((item, index) => (
                            <tr key={`bedroom-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`bedroom-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}

                        <tr><th>Foyer</th></tr>
                        {foyerThingsData.map((item, index) => (
                            <tr key={`foyer-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`foyer-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}

                        <tr><th>Living Room</th></tr>
                        {livingThingsData.map((item, index) => (
                            <tr key={`living-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`living-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}

                        <tr><th>Other Works</th></tr>
                        {otherWorkThingsData.map((item, index) => (
                            <tr key={`other-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`other-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}

                        <tr><th>Loose Furniture</th></tr>
                        {looseThingsData.map((item, index) => (
                            <tr key={`loose-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`loose-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}

                        <tr><th>Accessories</th></tr>
                        {accessoriesThingsData.map((item, index) => (
                            <tr key={`acc-${index}`}>
                                <td><p style={{ fontWeight: 'bold' }}>{item.name}</p></td>
                                {item.material.map((item2, index2) => (
                                    <td key={`acc-mat-${index2}`}>
                                        <p className='w-100'>{item2.label}</p>
                                        <p>{item2.value}</p>
                                        <p>{item2.oldValue}</p>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Row>
        </Container>
    )
}

export default PriceList